// extracted by mini-css-extract-plugin
export default {"tastes_block":"TasteItem_tastes_block__KcT--","count-block":"TasteItem_count-block__XCfeO"};